export default{
  'Data & Intelligence': require('@/assets/img/trend-icons/dfa-di.png'),
  'Intelligent Automation': require('@/assets/img/trend-icons/dfa-ia.png'),
  'Customer Experience': require('@/assets/img/trend-icons/dfa-cx.png'),
  'Internet of Things': require('@/assets/img/trend-icons/dfa-iot.png'),
  'Optimized IT': require('@/assets/img/trend-icons/dfa-oit.png'),
  'Cybersecurity': require('@/assets/img/trend-icons/dfa-cs.png'),
  'Insurance': require('@/assets/img/trend-icons/mkt-insurance.png'),
  'Industry': require('@/assets/img/trend-icons/mkt-industry.png'),
  'People & Healthcare': require('@/assets/img/trend-icons/mkt-people&healthcare.png'),
  'Energy & Utilities': require('@/assets/img/trend-icons/mkt-energy&utilities.png'),
  'Telco & Media': require('@/assets/img/trend-icons/mkt-telco&media.png'),
  'Banking': require('@/assets/img/trend-icons/mkt-banking.png')
}
